const keywordTrackerTypes = [
  "lexical",
  // key for this one used to be 'COMPANY_COMPETITORS'
  "competitive",
  "question_summary"
];
const KeywordAnalysisType = {
  COMPETITIVE_STRENGTH: "competitive_strength",
  COMPETITIVE_WEAKNESS: "competitive_weakness"
};
export {
  KeywordAnalysisType
};
//# sourceMappingURL=keyword.js.map
